export const TestIds = {
  switch: {
    container: 'ces-switch-container',
    offLabel: 'ces-switch-offLabel',
    onLabel: 'ces-switch-onLabel',
    root: 'ces-switch-root',
    thumb: 'ces-switch-thumb',
  },
};
